<template>
  <div id="app" v-loading="loading">
    <router-view />
  </div>
</template>

<script>
import store from '@/framework/store'
export default {
  name: 'App',
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    window.addEventListener('storage', (e) => {
      if (e.key === 'sessionEpoch') {
        window.location.reload()
      }
    })
  },
  computed: {
    lang() {
      return store.getters && store.getters.langMessages && store.getters.langMessages.chinese
    }
  },
  watch: {
    lang: {
      handler(newVal) {
        if(newVal) {
          this.loading = false;
        }
      },
      deep: true, // 深度监听对象内部变化
      immediate: true
    }
  }
}
</script>
